const LAST_REDIRECT_KEY = "populi:auth:last-reauth-redirect";

// A redirect that comes straight back into the same failure is a reload loop,
// which is worse than the error page. Two inside this window means logging in
// isn't fixing it.
const REDIRECT_LOOP_WINDOW_MS = 30000;

export const readLastRedirectAt = () => {
  try {
    return Number(window.sessionStorage.getItem(LAST_REDIRECT_KEY)) || 0;
  } catch {
    return 0;
  }
};

export const recordRedirect = () => {
  try {
    window.sessionStorage.setItem(LAST_REDIRECT_KEY, String(Date.now()));
  } catch {
    // Nothing to fall back on; losing loop protection beats blocking login.
  }
};

/**
 * Whether a re-authentication redirect happened recently enough that another
 * one would be a loop. Shared by every path that sends the user to Keycloak, so
 * they can't each burn their own attempt on the same broken session.
 */
export const isRecentRedirect = (at) =>
  Date.now() - at < REDIRECT_LOOP_WINDOW_MS;
